import { createTRPCContext } from '@trpc/tanstack-react-query'
import type { AppRouter } from './router.server'

export const { TRPCProvider, useTRPC, useTRPCClient } =
  createTRPCContext<AppRouter>()
